import { render, staticRenderFns } from "./todo-list-task-checklist.vue?vue&type=template&id=70d0fda2&"
import script from "./todo-list-task-checklist.vue?vue&type=script&lang=ts&"
export * from "./todo-list-task-checklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports